import brandTheme from 'Assets/Styles/brandTheme'

const { colors } = brandTheme()

export const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: 30,
  },
  button: {
    color: colors.primary,
    cursor: 'pointer',
  },
  title: {
    color: ' #7c7c7c',
    fontSize: 18,
    margin: '10px 0',
    textTransform: 'uppercase',
  },
  wrapperButtons: {
    display: 'flex',
    '&>div': {
      marginRight: 20,
      '&:first-child': {
        marginRight: 20,
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignTimeline/styles.js